// =============================================================================
// Logger - Development-Only Logging Utility
// =============================================================================
// PURPOSE: Provides consistent logging interface with production suppression.
//
// ARCHITECTURE:
// - debug/info: suppressed in production builds (console clutter reduction)
// - warn/error: always logged (critical issues visible in prod)
//
// KEY DECISIONS:
// - Environment-based suppression: keeps prod console clean for end users
// - Prefixed output: [DEBUG], [INFO], [WARN], [ERROR] for easy filtering
// =============================================================================

const isDev = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]) => {
    if (isDev) console.log("[DEBUG]", ...args);
  },
  info: (...args: unknown[]) => {
    if (isDev) console.info("[INFO]", ...args);
  },
  warn: (...args: unknown[]) => {
    console.warn("[WARN]", ...args);
  },
  error: (...args: unknown[]) => {
    console.error("[ERROR]", ...args);
  },
};
